// removed by extract-text-webpack-plugin
module.exports = {"headerPrimaryLarge":"_12g_EbVCCS-8VvIlOUVyGU","headerPrimaryMedium":"_3y27iiasoDuphZZ4VQBBj3","headerPrimarySmall":"_1Q0ag9I7c4C-pviW7O_cKO","headerSecondaryLarge":"nrWNR3thdRLtOX8XKly7a","headerSecondaryMedium":"_2JBaaLcXmx0k5VqQByARDW","headerSecondarySmall":"_1cQPwULQDLIh3Lo-nuNaBK","bodyHeaderPrimaryLarge":"EDgy12CdYb_zZ6JgVrAAm","bodyHeaderPrimaryMedium":"mupKZebWUyrhQB0NTYXE4","bodyHeaderPrimarySmall":"_1XAwFrGXDdDcrvh-x80jLX"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/dibs.scss
// module id = ./src/scss/dibs.scss
// module chunks = 4